import {
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { app, usingEmulators } from './app';

// La memòria cau persistent s'ha d'activar abans de qualsevol altra operació de Firestore (§20.1).
// Avís de seguretat en tancar sessió: §15. Aquest mòdul només el carreguen les pantalles que llegeixen dades.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
if (usingEmulators) connectFirestoreEmulator(db, '127.0.0.1', 8080);
